export default {
  'APP_NAME': '',
  'APP_DESC': ''
}



// WEBPACK FOOTER //
// ./src/config/common.config.js